import { render, staticRenderFns } from "./EditorDescriptionPanel.vue?vue&type=template&id=217273e8&scoped=true"
import script from "./EditorDescriptionPanel.vue?vue&type=script&lang=js"
export * from "./EditorDescriptionPanel.vue?vue&type=script&lang=js"
import style0 from "./EditorDescriptionPanel.vue?vue&type=style&index=0&id=217273e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217273e8",
  null
  
)

export default component.exports